<template>
  <div>
    <b-modal
      id="modal-preview"
      ref="modalPreview"
      title="收據預覽"
      title-class="text-primary"
      header-class="border-bottom-0"
      body-class="p-0"
      footer-class="justify-content-center"
      scrollable
      size="xl"
    >
      <div class="receipt-preview">
        <div class="pdfPreviewer" id="pdfPreviewer"></div>
      </div>
      <template v-slot:modal-footer="{}">
        <b-button
          v-if="isDownloadBtn && detailData.rpStatus == 1"
          class="btn btn-action"
          download="pdfPreview.pdf"
          @click="downloadCount"
          >收據下載</b-button
        >
        <b-button
          v-if="isHoldReceipBtn && detailData.rpStatus == 1"
          :variant="!detailData.isMarkHold ? 'action' : 'secondary'"
          :disabled="!detailData.isMarkHold ? false : true"
          @click="applyToMe()"
          >收據歸戶</b-button
        >
        <!-- <b-button variant="primary" @click="goHome">回收據雲平台首頁</b-button> -->
        <go-home-btn
          :btnVariant="'primary'"
          :btnName="btnName"
          :isHousehold="isHousehold"
          :resQueryCacheData="resQueryCacheData"
        >
          <template slot="goHomeBtn"></template>
        </go-home-btn>
      </template>
    </b-modal>
  </div>
</template>
<script>
// 共用 utils
import ApiMixin from '@/mixins/api';
import CommonApiMixin from '@/mixins/commonApi';
import UserMixin from '@/mixins/user';
import MakePdf from '@/mixins/makePdf';

export default {
  name: 'ReceiptPreview',

  mixins: [ApiMixin, MakePdf, UserMixin, CommonApiMixin],

  props: {
    isShowModal: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '收據預覽',
    },
    exportBaseName: {
      type: String,
      default: '',
    },
    isRpHmId: {
      type: Boolean,
      default: false,
    },
    // 下載btn開關
    isDownloadBtn: {
      type: Boolean,
      default: true,
    },
    // 歸戶btn開關
    isHoldReceipBtn: {
      type: Boolean,
      default: true,
    },
    // btn名字
    btnName: {
      type: String,
      default: '回收據雲平台首頁',
    },
    // 戶役政 開關
    isHousehold: {
      type: Boolean,
      default: false,
    },

    // UUID 查詢 的cache資料
    resQueryCacheData: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      rpDownloadCount: null, // 收據下載數量
      rowData: {},
      url: {}, // api url
      pdfName: '', // 檔案名稱
      typePreview: '', // 預覽類型
      printDataString: '',
      isIE: false, // IE開關
      detailData: {}, // 明細資料
    };
  },
  methods: {
    success(type, res, other) {
      let pdfData;
      let blob = res.data;
      const reader = new FileReader();
      const { data } = res;
      switch (type) {
        // 確認使用者
        case 'QueryUser':
          // / if (this.getCookieRunVal !== null) {
          //   if (this.getCookieRunVal !== '') {
          //     console.log('登入');
          //     this.queryCacheManager(this.getCookieRunVal);
          //   } else {
          //     console.log('沒登入 寫進uuid cookeie');
          //     // 寫進 cookie
          //     this.uuidCookie();
          //   }
          console.log('QueryUser', data);
          if (data === '') {
            console.log('未登入，走登入');
            // this.getUserInfo();
            this.uuidCookie();
          } else {
            console.log('已登入', this.detailData);
            this.upData(this.detailData);
            // const UserData = JSON.parse(data.object.dataMessage);
            // const userData = {
            //   userName: UserData.userName,
            // };
            // this.changeLogin(userData); // 寫進Vuex裡

            //  // 判斷歸戶
            // this.judgmentReturn(UserData, data.sessionId, data.sessionSource, UserData.hmId);
          }
          break;
        case 'CacheManagerQuery': // 有cookie狀態
          if (res.data.object === null) {
            console.log('沒資料，未登入');
            // 寫進 cookie
            this.uuidCookie();
          } else {
            const resultData = res.data.object;
            const UserData = JSON.parse(res.data.object.dataMessage);
            if (this.detailData.custRemarkList === null) {
              this.detailData.custRemarkList = [];
            }
            this.detailData.rpHmId = UserData.hmId;
            this.detailData.sessionId = resultData.sessionId;
            this.detailData.sessionSource = resultData.sessionSource;
            this.upData(this.detailData);
            console.log('有資料，有登入', res);
          }
          break;
        case 'receiptQuerySelectBox': // 下拉選單
          this.organList = res.data.object.organList;
          this.payItemList = res.data.object.payItemList;
          break;
        case 'CacheManagerInsert': // 寫完歸戶資料 轉倒到登入頁
          console.log('歸戶資料 轉倒到登入頁', res.data.object);
          if (res.data.object === true) {
            this.$userLogin();
          }
          break;
        case 'upData':
          console.log('歸戶成功', res.data.rtnCode);
          if (res.data.object === true) {
            this.showApiMessage(
              'success',
              `收據號碼：${this.rowData.rpPublicNo}已完成歸戶！`,
              '歸戶完成'
            );
          } else {
            this.showApiMessage('error', '歸戶失敗', '訊息');
          }
          this.apiLoading = false;
          break;
        case 'pdfPreview':
          pdfData = window.atob(res.data.object);
          if (res.data.object === null) {
            console.log('查無此檔案');
            // this.pdfPreviewAPI(this.rowData, this.url);
            /* 這 other 是 打API次數 */
            if (other === 1) {
              this.pdfPreview(this.rowData, this.url, 2);
            } else if (other === 2) {
              this.pdfPreview(this.rowData, this.url, 3);
            }
          } else {
            console.log('次數', other);
            this.pdf(pdfData);
          }
          break;
        case 'downloadQuery':
          console.log('有嗎?', res.data.object[0]);
          // eslint-disable-next-line prefer-destructuring
          this.detailData = res.data.object[0];
          this.rpId = res.data.object[0].rpId;
          this.rpDownloadCount = res.data.object[0].rpDownloadCount;
          console.log('預覽下載收據次數modal:', this.rpDownloadCount);

          break;
        case 'downloadCount':
          // safari application/pdf不吃 改用 .* 萬用類型 : application/octet-stream
          blob = blob.slice(0, blob.size, 'application/octet-stream');
          reader.readAsDataURL(blob);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(blob, `${this.pdfName}.pdf`);
          } else {
            reader.onload = (e) => {
              const a = document.createElement('a');
              a.download = `${this.pdfName}.pdf`;
              a.href = e.target.result;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            };
          }
          if (res.data) {
            this.downloadTimes();
          }
          break;
        case 'downloadTimes':
          this.rpDownloadCount += 1;
          console.log('下載次數:', this.rpDownloadCount);
          break;
        default:
          break;
      }
      this.apiStop();
      this.apiLoading = false;
    },
    fail(type, error, other) {
      switch (type) {
        case 'QrgetData':
          break;
        case 'upData':
          console.log('upData', error);
          this.showApiMessage('error', '歸戶失敗', '訊息');
          break;
        case 'pdfPreview':
          if (other === 1) {
            this.pdfPreview(this.rowData, this.url, 2);
          } else if (other === 2) {
            this.pdfPreview(this.rowData, this.url, 3);
          }
          console.log('pdfPreview', error);
          break;
        case 'print':
          console.log('print', error);
          break;
        case 'downloadCount':
          console.log('downloadCount', error);
          break;
        default:
          break;
      }
      this.apiLoading = false;
      this.apiStop();
    },

    showModal(rowData, url) {
      this.apiStart();
      this.rowData = rowData;
      this.url = url;
      this.axiosServiceSend(
        rowData,
        '/GovEReceipt/FrontDeskService/QueryFNTSF',
        'post',
        'downloadQuery'
      );

      this.pdfPreview(rowData, url, 1);
      this.pdfName = rowData.rpPublicNo;
      this.$root.$emit('bv::show::modal', 'modal-preview');
    },

    async pdfPreview(data, url) {
      this.axiosServiceSend({}, url.preview, 'post', 'pdfPreview');
    },
    // 製作pdf
    async pdf(pdfData) {
      this.$_makePdf(pdfData);
      this.$nextTick(() => {
        if (this.typePreview === 'createCounter') {
          this.$emit('isLoad', false);
        }
      });
    },

    // 下載次數
    downloadCount() {
      const other = {
        responseType: 'blob',
      };
      this.axiosServiceSend({}, this.url.downloadPdf, 'post', 'downloadCount', other);
      // this.axiosServiceSend(this.rowData, this.url.downloadPdf, 'post', 'downloadCount', other);
    },
    downloadTimes() {
      const data = {
        rpId: this.rpId,
        rpDownloadCount: this.rpDownloadCount,
      };
      this.axiosServiceSend(data, '/GovEReceipt/ReceiptService/count', 'post', 'downloadTimes');
    },
    /** 歸戶收據 起 */
    // 歸戶收據
    applyToMe() {
      this.queryUser();
      // this.getCookieRunVal = this.$getUUID('sessionId');
      // console.log('getCookieRunVal:', this.getCookieRunVal);
      // this.$nextTick(() => {
      //   // if (this.getCookieRunVal !== null) {
      //   if (this.getCookieRunVal !== '') {
      //     console.log('登入');
      //     this.queryCacheManager(this.getCookieRunVal);
      //   } else {
      //     console.log('沒登入 寫進uuid cookeie');
      //     // 寫進 cookie
      //     this.uuidCookie();
      //   }
      // });
    },
    // 確認使否有登入
    async queryUser() {
      const url = '/GovEReceipt/FrontDeskService/QueryUser';
      await this.axiosServiceSend({}, url, 'post', 'QueryUser');
    },
    async queryCacheManager(sessionId) {
      console.log('打API檢查是否有此資料', sessionId);
      const data = {
        sessionId,
        sessionSource: 'H',
      };
      const url = '/GovEReceipt/CacheManagerService/Query';
      this.axiosServiceSend(data, url, 'post', 'CacheManagerQuery');
    },
    // 把uuid 寫進 cookie
    uuidCookie() {
      const exp = new Date();
      exp.setTime(exp.getTime() + 30 * 60 * 1000);
      const expires = this.$moment(exp).format('yyyy-MM-DD HH:mm:ss.SSS');
      document.cookie = `sessionUUId=${this.uuid};expires=${exp.toGMTString()}`;
      const data = {
        sessionId: this.uuid,
        sessionSource: 'H',
        sessionExpireDate: expires,
        dataMessage: JSON.stringify(this.detailData),
      };
      this.insertCacheManager(data);
    },

    // 歸戶 寫進明細資料備存
    async insertCacheManager(data) {
      console.log('寫進資料備存:', data);

      const url = '/GovEReceipt/CacheManagerService/Insert';
      this.axiosServiceSend(data, url, 'post', 'CacheManagerInsert');
    },
    // // 更新收據資料
    async upData(data) {
      console.log('取data:', data);
      const changeItme = data;
      changeItme.sessionSource = 'H';
      const url = '/GovEReceipt/FrontDeskService/Update';
      const method = 'post';
      this.axiosServiceSend(data, url, method, 'upData');
    },
    goHome() {
      this.$router.push({
        name: 'home',
      });
    },
  },
};
</script>
